SOURCES = ['delivery_club', 'external_site', 'external_site_mobile', 'marketplace', 'marketplace_mobile', 'board', 'mobile_application_ios', 'mobile_application_android', 'foodfox', 'obed_ru', 'broniboy', 'chibbis', 'glovo', 'vk', 'sbermarket', 'yandex_lavka']

App.PagesTableComponent = Em.Component.extend
  classNames: ['pages-table']

  sort: 'position'
  sortAscending: true
  sortByName          : Em.computed.equal 'sort', 'name'
  sortBySlug          : Em.computed.equal 'sort', 'slug'
  sortByPosition      : Em.computed.equal 'sort', 'position'
  sortByShowInApp     : Em.computed.equal 'sort', 'show_in_app'
  sortByShowInWeb     : Em.computed.equal 'sort', 'show_in_web'

  selectedVisibility: (->
    ['show_in_app', 'show_in_web'].map (item) =>
      id: item
      label: Em.I18n.t "static_pages.table.content.#{item}"
      checked: false
  ).property('selectedVisibility')

  searchQuery: ''

  debouncedSearchQuery: null
  debouncedSearchQueryTimeout: null

  debounceSearchQuery: (->
    Em.run.cancel @get('debouncedSearchQueryTimeout')
    if Em.isEmpty(@get('searchQuery'))
      @set('debouncedSearchQuery','')
      return
    @set('debouncedSearchQueryTimeout', Em.run.later @, ->
      @set('debouncedSearchQuery', @get('searchQuery'))
      @set('debouncedSearchQueryTimeout',null)
    , 2000)
  ).observes('searchQuery')

  tableHeadings: (->
    headings = [
      { sortBy: 'name', heading: 'static_pages.table.content.name' },
      { sortBy: 'slug', heading: 'static_pages.table.content.slug' },
      { sortBy: 'show_in_app', heading: 'static_pages.table.content.show_in_app' },
      { sortBy: 'show_in_web', heading: 'static_pages.table.content.show_in_web' },
      { sortBy: 'position', heading: 'static_pages.table.content.position' },
    ]

    headings.forEach (heading) =>
      camelizedHeading = _.camelCase(heading.sortBy)
      formattedHeading = "#{camelizedHeading.charAt(0).toUpperCase()}#{camelizedHeading.slice(1)}"
      heading.sorted = @get("sortBy#{formattedHeading}")
    headings
  ).property('sort')

  filterQueryPages: (->
    selectedVisibility = @get('selectedVisibility')
    searchQuery = @get('debouncedSearchQuery')?.toLowerCase()


    # Получаем оригинальный массив промо
    pages = @get('pages') || []
    # Применяем фильтры
    filteredPages = pages.filter (page) =>
      matchedFilters = []
      if !Em.isEmpty(searchQuery)
        pageName = page.get('name')?.toLowerCase() || ''
        matchedFilters.push(pageName.includes(searchQuery))
      if !Em.isEmpty(selectedVisibility.filter (item) => item.checked)
        matchedFilters.push(selectedVisibility.filter (item) => item.checked
        .some (item) => page.get(item.id))

      # Проверяем, соответствует ли элемент всем фильтрам
      matchedFilters.every (el) => el

    # Возвращаем отфильтрованный массив
    filteredPages
  ).property(
    'pages.[]',
    'debouncedSearchQuery',
    'selectedVisibility.@each.checked'
  )

  actions:
    sortBy: (propertyName) ->
      currentSort = @get 'sort'
      sortAscending = @get 'sortAscending'
      # Если уже сортируем по текущему столбцу, инвертируем направление
      if currentSort is propertyName
        @toggleProperty 'sortAscending'
        sortAscending = @get 'sortAscending'
      else
        # Устанавливаем новый ключ сортировки и по умолчанию сортируем по возрастанию
        @set 'sort', propertyName
        @set 'sortAscending', true
        sortAscending = true

      # Получаем список промо и сортируем их
      pages = @get 'pages'

      # Обрабатываем сортировку, учитывая случаи, когда значение отсутствует
      sortedPages = _.sortBy(pages.toArray(), (el) ->
        value = el.get(propertyName)
        # Устанавливаем значение для отсутствующих данных, чтобы они сортировались корректно
        if value? then value else (if sortAscending then Infinity else -Infinity)
      )

      # Если требуется сортировка по убыванию, инвертируем массив
      unless sortAscending
        sortedPages = sortedPages.reverse()

      # Обновляем список промо
      @set 'pages', sortedPages

      false

    openStaticPage: (page) ->
      @sendAction('openStaticPage', page)
      false

    toggleFilters: ->
      @toggleProperty('isFiltersVisible')
      false

    updateActiveFrom: (val) ->
      @set('activeFrom', val)
      false

    updateActiveTill: (val) ->
      @set('activeTill', val)
      false



